/* eslint-disable */
import React from 'react';
import classNames from 'classnames';
import { Typography, Paper, TextField, Chip, MenuItem, Icon } from '@material-ui/core';

export const NoOptionsMessage = props => {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  );
};

const inputComponent = ({ inputRef, ...props }) => {
  return <div ref={inputRef} {...props} />;
};

export const Control = props => {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
};

export const Option = props => {
  const optionLabel =
    typeof props.label === 'string'
      ? props.label
      : typeof props.data?.label === 'string'
      ? props.data.label
      : typeof props.children === 'string'
      ? props.children
      : undefined;
  const isOptionDisabled = props.isDisabled || props.data?.isPartDisabled || props.data?.isDisabled;

  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      title={optionLabel}
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        borderRadius: '10px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        height: 'auto',
        minHeight: 48,
        lineHeight: 1.35,
        paddingTop: 8,
        paddingBottom: 8,
        color: isOptionDisabled ? 'rgba(0, 0, 0, 0.38)' : undefined,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
};

export const Placeholder = props => {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  );
};

export const SingleValue = props => {
  const isDisabled = props.selectProps.isDisabled || props.data?.isPartDisabled;
  const valueLabel =
    typeof props.data?.label === 'string'
      ? props.data.label
      : typeof props.children === 'string'
      ? props.children
      : undefined;

  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      title={valueLabel}
      style={isDisabled ? { color: 'rgba(0, 0, 0, 0.38)' } : {}}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
};

export const ValueContainer = props => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
};

export const MultiValue = props => {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      disabled={props.data.isDisabled}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<Icon {...props.removeProps}>cancel</Icon>}
    />
  );
};

export const Menu = props => {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
};
